import React, {
	Component
} from 'react';

export default class OrganizationSearch extends Component {

	constructor(props) {
		super(props);
		console.log("hostname is " + process.env.REACT_APP_HOST_API_URL);
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	validateResponse = (response) => {
		console.log('in validateResponse');
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response;
	}

	logResult = (result) => {
		console.log('I love this result .... \n\n\n', result);
	}

	searchOrgs = (props) => {
		console.log('searching for orgs with name ' + props.organizationName);
		var jsonData = null;
		fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/organizations/search?name=' + props.organizationName + '&orgType=FIRST_NET&orgMemberType=CORPORATE', {
				headers: {
					'Accept': 'application/json',
				},
				credentials: 'include'
			})

			.then(results => {
				this.validateResponse(results);
				this.logResult(results);
				return results.json();
			})
			.catch(error => {
				console.log('error trying to fetch orgs : \n', error);
				return Promise.reject()
			})
			.then(data => {
				console.log(data);
				this.props.handleOrgSearchResults(data);
				return jsonData;
			});
	}

	render() {
		return ( 
			<div />
		)
	}

}


// WEBPACK FOOTER //
// ./src/manageOrg/OrganizationSearch.js